import { getSessionData } from "../../../helpers/sessionDetailsParser";
import {
  deleteCustomer,
  deleteDirectEntryProductType,
  deleteLedger,
  deleteOrder,
  deleteOrderProduct,
  deletePersonalDetails,
  deleteProduct,
  deleteProductType,
  deleteProductTypeWithOutHUID,
  deleteUser,
} from "../../../helpers/urlConfig/apiFunctions";

export const constructBody = (keyName, deleteId, deleteName) => {
  switch (keyName) {
    case "Product":
      return {
        product_id: deleteId,
        product_name: deleteName,
        updated_by: getSessionData("user_id"),
      };
    /** If Key Name is Product Type, Then It Sends Body as full data */
    case "ProductType":
      return {
        data: deleteId,
        updated_by: getSessionData("user_id"),
      };
    case "ProductTypeWithOutHUID":
      return {
        product_type_id: deleteId,
        updated_by: getSessionData("user_id"),
      };
    case "Customer":
      return {
        customer_id: deleteId,
        updated_by: getSessionData("user_id"),
      };
    case "User":
      return {
        user_id: deleteId,
        updated_by: getSessionData("user_id"),
      };
    case "Order":
      return {
        id: deleteId,
        updated_by: getSessionData("user_id"),
      };
    case "Order Product":
      return {
        id: deleteId,
        updated_by: getSessionData("user_id"),
      };
    case "PersonalDetails":
      return {
        id: deleteId,
        updated_by: getSessionData("user_id"),
      };

    case "Customer Ledger":
      return {
        id: deleteId,
        updated_by: getSessionData("user_id"),
        idType: deleteName,
      };
    default:
      return "Invalid Key Name";
  }
};

export const apiFunctionCall = (keyName, body) => {
  let pairCount;
  let gram;
  let inputJSON;
  let pairs;
  let huid;
  let unique_stock_id;
  let description = "Return From With HUID To With Out HUID";

  switch (keyName) {
    case "Product":
      return deleteProduct(body);

    case "ProductType":
      if (body.data.stock_type === "Incoming Stock") {
        console.log("body.data.unique_stock_id", body.data.unique_stock_id);
        return deleteDirectEntryProductType({
          unique_stock_id: body.data.unique_stock_id,
        });
      } else {
        pairCount =
          body.data.pairs !== null ? JSON.parse(body.data.pairs).length : 1;

        pairs = body.data.pairs ? JSON.parse(body.data.pairs) : null;

        huid = body.data.huid ? body.data.huid : null;

        gram = parseFloat(body.data.gram);

        unique_stock_id = body.data.unique_stock_id;

        inputJSON = {
          product_type_id: body.data.product_type_id,
          product_name: body.data.product_name,
          model_name: body.data.model_name,
          product_type_name: body.data.product_type_name,
          pairCount: pairCount,
          pairs: JSON.stringify(pairs),
          huid: huid,
          gram: gram,
          unique_stock_id: unique_stock_id,
          description: description,
          updated_by: getSessionData("user_id"),
        };

        return deleteProductType(inputJSON);
      }

    case "ProductTypeWithOutHUID":
      return deleteProductTypeWithOutHUID({
        product_type_id: body.product_type_id.product_type_id,
        updated_by: getSessionData("user_id"),
        stock: body.product_type_id.stock,
        gram: body.product_type_id.gram,
        model_name: body.product_type_id.model_name,
      });
    case "Customer":
      return deleteCustomer(body);
    case "User":
      return deleteUser(body);
    case "Order":
      return deleteOrder(body);
    case "Order Product":
      return deleteOrderProduct(body);
    case "PersonalDetails":
      return deletePersonalDetails(body);
    case "Customer Ledger":
      return deleteLedger(body);
    default:
      return "Invalid Key Name";
  }
};
